import { Authantication } from './authService';
import { Dashboard } from './dashboard';
import { PlantService } from './plantService';
import { InverterService } from './inverterService';
import { CustomerService } from './customerService';
import { UserService } from './usersService';

import { AlarmsService } from './alaermsService';


export const authService = new Authantication();
export const dashboardService = new Dashboard();
export const inverterService = new InverterService();
export const plantService = new PlantService();
export const customerService = new CustomerService();
export const usersService = new UserService();
export const alarmsService = new AlarmsService();
